export function getColorVariationFromPrimaryColorBasedOnIndex(
    index,
    color = "#4A3AFF",
) {
    const baseColor = color.replace("#", "")

    const r = parseInt(baseColor.substring(0, 2), 16)
    const g = parseInt(baseColor.substring(2, 4), 16)
    const b = parseInt(baseColor.substring(4, 6), 16)

    const variationFactor = 0.08 * index

    const newR = Math.min(255, Math.floor(r + (255 - r) * variationFactor))
    const newG = Math.min(255, Math.floor(g + (255 - g) * variationFactor))
    const newB = Math.min(255, Math.floor(b + (255 - b) * variationFactor))

    return `rgb(${newR}, ${newG}, ${newB})`
}